<template>
  <v-container
    class="align-stretch layout-container"
    data-testid="topics-page"
  >
    <BaseHeader
      :title="$t('topics.title')"
      :style-variant="11"
    >
      <template
        v-if="!isPlatformBottimmo"
        v-slot:design
      >
        <HeaderDesign />
      </template>

      <template v-slot:desc>
        <p>{{ $t('topics.headerDescription') }}</p>
      </template>
    </BaseHeader>

    <TopicList />
  </v-container>
</template>

<script>
import BaseHeader from '@/components/BaseHeader'
import brandingMixin from '@/mixins/branding.js'

import HeaderDesign from './HeaderDesign'
import TopicList from './TopicList'

export default {
  components: {
    BaseHeader,
    HeaderDesign,
    TopicList,
  },
  mixins: [brandingMixin],
}
</script>
